/** Shared dashboard page header layout tokens (header row + collapsible actions). */

/** Vertical rhythm between breadcrumbs, title, and toolbar on dashboard pages. */
const dashboardStackSpacingSx = {
  mb: { xs: 0.75, sm: 2 },
} as const;

export const dashboardBreadcrumbsSx = dashboardStackSpacingSx;

export const dashboardPageHeaderTitleSlotSx = {
  flex: '1 1 auto',
  minWidth: 0,
} as const;

/** Applied on the heading Typography (not the outer flex container). */
export const dashboardPageHeaderTitleTypographySx = {
  fontSize: { xs: '1.375rem', sm: '2.5rem' },
  lineHeight: { xs: 1.25, sm: 1.2 },
} as const;

export const dashboardPageHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: { xs: 1, sm: 2 },
  flexWrap: 'nowrap',
  ...dashboardStackSpacingSx,
  minWidth: 0,
} as const;

export const dashboardPageHeaderActionsSx = {
  display: 'flex',
  gap: 1.5,
  alignItems: 'center',
  flexShrink: 0,
  flexWrap: 'wrap',
} as const;

export const dashboardPageHeaderPrimaryActionsSx = {
  ...dashboardPageHeaderActionsSx,
  justifyContent: 'flex-end',
} as const;
